<template>
  <div class="MapInfo_bigbox">
    <div class="MapInfo_big_box" :class="translateX == 100?'zIndexTop':''"></div>
    <div class="MapInfo" :style="{ 'transform': `translateX(${this.translateX}%)`}">
      <div class="MapInfo_box">
        <div class="close_MapInfo_content">
          <div @click="closeMap()">
            <i class="iconfont icon-guanbi3"></i>
          </div>
        </div>
        <div class="MapInfo_content" id="MapInfo_content">
          <!-- 指标体系 -->
          <div v-show="menuIdx== 0" class="MapInfo_content_div_indicator">
            <div class="indicator_box">
              <div
                v-for="(item,index) in indicatorTitleDataList"
                :key="index"
                :style="[{'background': idx_ == index? color:''}]"
              >
                <div @click="toTitle(item.id,index)">{{item.title}}</div>
              </div>
            </div>
            <div class="content_html" :class="[language == 'zh'?'zhFamily':'enfamily']"  v-html="indicatorDataHtml"></div>
          </div>

          <!-- 故事与数据 -->
          <div v-show="menuIdx== 1" class="MapInfo_content_div_video">
            <div class="title_box">
              <div class="hr" :style="{'background':color}"></div>
              <div class="title" :style="{'color':color}" >{{$t('knowledgeBase.story')}}</div>
            </div>
            <StoryData :color_value="color" ></StoryData>
          </div>
       
          <!-- <div class="content_btn" :style="{'background':color}">
            <div v-show="!(activeIdx  == 0)"  @click="toModule(0,42)">
              <p>{{$t('knowledgeBase.indicatorSystem')}}</p>
              <div class="sdg_btn_box_i">
                <div class="hr_"></div>
                <div class="sdg_btn_box_i_posi">
                  <i class="iconfont icon-jiantou"></i>
                </div>
              </div>
            </div>
            <div v-show="!(activeIdx  == 1)" :style="{'background':color}" @click="toModule(1)">
              <p>{{$t('knowledgeBase.story')}}</p>
              <div class="sdg_btn_box_i">
                <div class="hr_"></div>
                <div class="sdg_btn_box_i_posi">
                  <i class="iconfont icon-jiantou"></i>
                </div>
              </div>
            </div>

          </div> -->
          <!-- <div class="next_taget" @click="nextTarget()">
            <div class="text" :style="{'color':nextColor}">下一目标：确保包容和公平的优质教育，让全民终身享有学习机会</div>
            <div class="posi_" :style="{'background':nextColor}"></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { targetList, indicatorList, indicator, video } from "@/axios/api.js";
import bus from "@/bus";
export default {
  data() {
    return {
      indicatorDataHtml: null,
      indicatorTitleDataList: [],
      titleList: null,
      hoverIndicatorIdx: -1,
      nextColor: "",
      activeIdx: 0,
      color: "",
      translateX: 100,
      menuIdx: -1,
      indicatorArray: [],
      bg_color: null,
      index: null,
      idx_: 0,
      id:null,
      videoList: null,
      goal:null,
    };
  },
 components: {
    StoryData: () => import("./storyData.vue"),

  },
  destroyed() {
    let that = this;
  },
  mounted() {
    // this.getTargetList();
    bus.$on("openMenuFun", obj => {
      this.goal = obj.id;
      this.activeIdx = obj.idx;
      this.nextColor = obj.bg_color[obj.index + 1];
      this.bg_color = obj.bg_color;
      this.index = obj.index;
      this.color = this.bg_color[this.index];
      this.id = obj.idx;
      if( obj.idx == 0){
           this.getIndicatorList(obj.id, obj.idx)
      }else{
         bus.$emit("openMenuFun1",{id: this.goal})
          this.openMenu(obj.idx);
      }
     ;
      // this.getVideoList(obj.id);
    });
    const navContents = document.querySelectorAll(".toc-link");
  },
  methods: {
    // async getVideoList(id) {
    //   var res = await video(id);
    //   this.videoList = res.data.data;
    // },
    toTitle(id, index) {
      this.idx_ = index;
      this.getIndicator(id);
    },
    async getIndicator(id) {
      // window.removeEventListener("click", this.aClick);
      var res = await indicator(id);
      this.indicatorDataHtml = res.data.data.content;
      window.addEventListener('click',this.aClick)
    },
    aClick(event) {
      //获取锚点列表
      const navContents = document.querySelectorAll(".toc-link");
      navContents.forEach((item, index) => {
        item.setAttribute("href", "javascript:void(0)");
        item.setAttribute("ids", index);
      });
    },
    beforeDestroy() {
      // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
      window.removeEventListener("click", this.aClick);
    },
    async getIndicatorList(id, idx) {
      var res = await indicatorList(id);
      if (res.status == 200) {
        this.indicatorTitleDataList = [];
        var indicatorData = res.data.data;
        if (indicatorData.length > 0) {
          indicatorData.forEach(item => {
            this.indicatorTitleDataList.push({
              title: item.title,
              id: item.id
            });
          });
          this.indicatorDataHtml = indicatorData[0].content;
        }
        this.openMenu(idx);
        this.backTop();
      }
    },
    async getTargetList() {
      var res = await targetList(1);
      this.indicatorArray = res.data.data;
      // console.log(res.data.data);
    },
    nextTarget() {
      if (this.index < 16) {
        this.index++;
      } else {
        this.index = 0;
      }

      this.menuIdx = 0;
      this.activeIdx = 0;
      this.color = this.nextColor;
      this.nextColor = this.bg_color[this.index];
            // this.getIndicatorList(this.id+1, this.activeIdx );
      this.backTop();
    },
    hoverIndicator(idx) {
      this.hoverIndicatorIdx = idx;
    },
    toModule(val) {
      this.menuIdx = val;
      this.activeIdx = val;
      bus.$emit("openMenuFun1",{id:this.goal})
      this.backTop();
    },
    backTop() {
      let timer = setInterval(function() {
        var top =
          document.getElementById("MapInfo_content").scrollTop ||
          document.getElementById("MapInfo_content").scrollTop;
        var speed = top / 4;
        if (document.getElementById("MapInfo_content").scrollTop != 0) {
          document.getElementById("MapInfo_content").scrollTop -= speed;
        } else {
          document.getElementById("MapInfo_content").scrollTop -= speed;
        }
        if (top == 0) {
          clearInterval(timer);
        }
      }, 15);
    },
    closeMap() {
      this.translateX = 100;
      document.querySelector("body").setAttribute("style", "overflow-y: auto;");
    },
    openMenu(idx) {
      this.menuIdx = idx;
      this.translateX = 0;
      document
        .querySelector("body")
        .setAttribute("style", "overflow-y: hidden;");
    }
  }
};
</script>

<style lang="scss" >
// .MapInfo_bigbox{
//   position: absolute;
//   top: 0;
//   right: 0;
//   left: 0;
// }
.MapInfo_big_box {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 199;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  -moz-backdrop-filter: blur(30px);
  //  -moz-background-color: rgba(237,239,240,.95);
}
.zIndexTop {
  z-index: -1 !important;
}
.MapInfo {
  transition: all 0.4s ease;
  background-color: transparent;
  //   height: 1px;
  width: 100%;
  position: fixed;
  top: 0px;
  right: 0;
  bottom: 0;
  overflow-x: hidden;
  z-index: 999;
  // -webkit-backdrop-filter: blur(30px);
  // backdrop-filter: blur(30px);
  // background-color: transparent;
  -moz-background-color: rgba(237, 239, 240, 0.85) !important;
  min-height: calc(100vh - 0px);
  // opacity: 0;
  // visibility: hidden;
  transition: all 400ms ease;
}

.MapInfo_box {
  height: 100%;
  display: flex;
  flex-flow: row wrap;
}
.close_MapInfo_content {
  padding-top: 50px;
  width: 13%;
  //   height: 100%;
  background: transparent;
  overflow-y: auto;
  //   position: fixed;
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: row;
  i {
    font-size: 60px;
    cursor: pointer;
    color: #fff;
  }
}
.MapInfo_content {
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
  height: 100%;
  padding: 0 20px;
  background: #fff;
  h4 {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  p {
    font-size: 16px;
  }
}
.title_box {
  display: flex;
  height: 36px;
  width: 100%;
  align-items: center;
  margin: 20px 0;
  .hr {
    width: 10px;
    height: 100%;
  }
  .title {
    flex: 1;
    line-height: 36px;
    color: #fff;
    padding-left: 10px;
    font-size: 16px;
    font-weight: 600;
    background: rgba(234, 234, 234, 1);
  }
}
.MapInfo_content_div_indicator {
  display: flex;
  flex-direction: column;
}
/* 读取标签字符串的内部标签 */
.content_html {
  .wiki-content .header,
  .wiki-content .footer,
  .wiki-content .cell {
    margin: 8px 0;
    box-sizing: border-box;
    word-wrap: break-word;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }
  .wiki-content h3 {
    font-size: 16px;
    line-height: 1.5;
    margin: 30 px 0 0 0;
  }

  element.style {
  }

  user agent stylesheet strong {
    font-weight: bold;
  }

  user agent stylesheet strong {
    font-weight: bold;
  }

  style attribute {
    color: rgb(255, 0, 0);
  }

  .confluence-information-macro {
    background: #fcfcfc;
    border: 1px solid #ccc;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    color: #333;
    margin: 10px 0 1em 0;
    min-height: 20px;
    padding: 10px 10px 10px 36px;
    position: relative;
  }
  .aui-group,
  .aui-tabs,
  blockquote,
  dl,
  form.aui,
  ol,
  p,
  pre,
  table.aui,
  ul {
    margin: 10px 0 0;
  }
  .toc-macro.hidden-outline span.toc-outline {
    display: none;
  }
  .assistive,
  form.aui legend.assistive {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  .no-labels-message {
    display: none;
  }
}
.content_html ul li {
  margin-left: 20px;
  list-style: disc !important;
}
.MapInfo_content_div_indicator,
.MapInfo_content_div_video,
.MapInfo_content_div_report {
  padding-top: 20px;
  width: 100%;
}
.MapInfo_content_div_report img {
  width: 100%;
}
.indicator_box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  > div {
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, 0.6);

    margin-right: 10px;
    margin-bottom: 6px;
    border-radius: 20px;
    > div {
      padding: 10px 8px;
    }
    // margin-bottom: 20px;
    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }
}
.next_taget {
  margin-top: 10px;
  height: 36px;
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
  padding: 0 5px;
  position: relative;
  cursor: pointer;
  &:hover .posi_ {
    position: absolute;
    //  left: 5px !important;
    // right: 5px !important;
    width: calc(100% - 10px) !important;
    z-index: 33 !important;
    transition: 0.4s cubic-bezier(0.42, 0, 0.58, 1);
  }
  .posi_ {
    position: absolute;
    left: 5px;
    top: 0;
    right: 5px;
    width: 10px;
    height: 100%;
    z-index: 99;
    transition: 0.4s cubic-bezier(0.42, 0, 0.58, 1);
  }

  .text {
    position: absolute;
    width: 100%;
    height: 100%;
    color: #fff;
    font-weight: 600;
    line-height: 36px;
    font-size: 16px;
    padding-left: 30px;
    z-index: 9999;
    cursor: pointer;
    transition: 0.2s cubic-bezier(0.42, 0, 0.58, 1);
  }
  &:hover .text {
    color: #fff !important;
    z-index: 999;
    transition: 0.2s cubic-bezier(0.42, 0, 0.58, 1);
  }
  // background:
}
.content_btn {
  margin-top: 0px;
  margin-bottom: 30px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  div {
    width: 100%;
    // flex: 1;
    height: 100%;
    line-height: 36px;
    text-align: center;
    align-items: center;
    display: flex;
    // background: rgba(194,31,50,1);
    color: #fff;
    justify-content: center;
    flex-direction: row;
    margin: 0 5px;
    &:hover {
      opacity: 0.6;
      transition: 0.8s;
    }

    &:hover .hr_ {
      width: 120px !important;
    }
    p {
      font-size: 16px;
    }
    // padding: 10px 0;
    .sdg_btn_box_i {
      width: 120px;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 10px;

      .hr_ {
        width: 0px;
        height: 2px;
        // margin-left: -30px;
        background: #fff;
        transition: 0.3s;
      }

      .sdg_btn_box_i_posi {
        position: relative;
        i {
          font-weight: 600;
          font-size: 16px;
          color: #fff;
          position: absolute;
          left: -20px;
          top: 2px;
        }
      }
    }
  }
}
.MapInfo_content_map {
  height: calc(100vh - 170px);
  // height: 900px;
  width: 100%;
  position: relative;
  background: rgba(222, 168, 60, 1);
}
.MapInfo_content_header_title1 {
  color: rgba(222, 168, 60, 1);
  font-size: 36px;
  text-align: left;
  margin-top: 10px;
}
.MapInfo_content_header_title2 {
  color: rgba(222, 168, 60, 1);
  font-size: 44px;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 30px;
}
.dataWarehouse_box {
  margin-top: 20px;
  display: flex;
  flex: 3;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
}
.dataWarehouse_title {
  font-size: 26px;
  font-weight: 600;
  width: 260px;
  padding: 8px 1px;
  border-bottom: 3px solid #333;
}
.dataWarehouse {
  cursor: pointer;
  width: 32%;
  padding: 4px 5px 20px;
}
.dataWarehouse_img {
  width: 100%;
  height: 180px;
  //  padding-bottom: 20%;
}
.dataWarehouse_img img {
  width: 100%;
  // padding-bottom: 50%;
  height: 100%;
}
.dataWarehouseName {
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 30px;
  text-align: left;
}
.next_toSDG {
  cursor: pointer;
  background: rgba(78, 159, 56, 1);
  height: 120px;
  width: 100%;
  display: flex;
}
.next_toSDG_p1 {
  color: #fff;
  line-height: 120px;
  font-size: 86px;
  font-weight: 600;
  margin-left: 120px;
  position: relative;
}
.next_toSDG_p2 {
  color: #fff;
  line-height: 120px;
  font-size: 30px;
  font-weight: 600;
  margin-left: 120px;
  position: relative;
}

.toSdg {
  display: flex;
}
.toSdg p {
  font-weight: 600;
  margin-right: 10px;
}
.eachrsSelect {
  display: flex;
}
.eachrsSelect li {
  padding: 10px 20px;
  margin: 20px 4px 0;
  background: #f8f8f8;
  cursor: pointer;
}
.eachrsSelect li:first-child {
  background: rgba(222, 168, 60, 1);
  color: #fff;
}
#map {
  position: absolute;
  top: 20px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
.content_info {
  width: 100%;
  height: calc(100vh - 160px);
  background: rgba(222, 168, 60, 1);
}
.content_info_img_text {
  display: flex;
  align-items: center;
  padding: 20px;
  justify-content: space-between;
}
.content_info_img_text_p {
  display: flex;
  flex-direction: column;
}
.content_info_img_text_p p {
  text-align: left;
  color: #fff;
  margin-bottom: 20px;
  text-indent: 28px;
  font-size: 16px;
}
.content_info div img {
  margin-left: 30px;
}
.video {
  margin: 10px;
}
</style>